import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Layout } from "@/components/Layout";
import { TimetableGrid } from "@/components/TimetableGrid";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function AdminTimetable() {
    const [classes, setClasses] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [classId, setClassId] = useState("");
    const [slots, setSlots] = useState([]);
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState(null); // {day, period, current}

    const refresh = async (cid) => {
        if (!cid) return;
        const r = await api.get(`/timetable/${cid}`);
        setSlots(r.data);
    };
    useEffect(() => {
        (async () => {
            try {
                const [c, s] = await Promise.all([api.get("/classes"), api.get("/subjects")]);
                setClasses(c.data); setSubjects(s.data);
                if (c.data.length > 0) {
                    setClassId(c.data[0].id);
                    await refresh(c.data[0].id);
                }
            } finally { setLoading(false); }
        })();
    }, []);

    const handleClassChange = async (cid) => {
        setClassId(cid);
        await refresh(cid);
    };

    const onCellClick = (day, period, current) => {
        setEdit({ day, period, subject_id: current?.subject_id || "" });
    };

    const saveSlot = async (subject_id) => {
        await api.post("/timetable/slot", {
            class_id: classId, day: edit.day, period: edit.period,
            subject_id: subject_id || null,
        });
        setEdit(null);
        refresh(classId);
    };

    // Filter subjects by class direction
    const klass = classes.find((c) => c.id === classId);
    const direction = klass?.direction || "all";
    const filteredSubjects = subjects.filter((s) => s.direction === "all" || s.direction === direction || direction === "all");

    return (
        <Layout>
            <Link to="/admin" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-oxford mb-4">
                <ArrowLeft className="w-4 h-4" /> Mbrapa te admin
            </Link>
            <div className="mb-6">
                <div className="text-xs uppercase tracking-[0.18em] text-slate-500 mb-2">Orari</div>
                <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">Menaxho Orarin</h1>
                <p className="text-slate-600 mt-2 text-sm">Cakto lëndë për çdo orë / ditë / klasë</p>
            </div>

            <div className="mb-4 flex flex-wrap items-center gap-2">
                <label className="text-xs font-bold uppercase tracking-widest text-slate-500">Klasa</label>
                <select value={classId} onChange={(e) => handleClassChange(e.target.value)} className="h-9 rounded-md border border-slate-300 bg-white text-sm px-2 font-semibold" data-testid="tt-class-select">
                    {classes.map((c) => <option key={c.id} value={c.id}>{c.name} • Viti {c.year}</option>)}
                </select>
            </div>

            {loading ? <div>Duke ngarkuar…</div> : (
                <TimetableGrid slots={slots} subjects={filteredSubjects} editable onCellClick={onCellClick} />
            )}

            <Dialog open={!!edit} onOpenChange={(v) => !v && setEdit(null)}>
                <DialogContent>
                    <DialogHeader><DialogTitle className="font-heading">Cakto lëndën</DialogTitle></DialogHeader>
                    <div className="space-y-2">
                        <button onClick={() => saveSlot(null)} className="w-full text-left p-3 rounded-lg border-2 border-slate-200 hover:border-terracotta text-sm font-bold text-terracotta" data-testid="tt-clear-slot">— Pastro këtë orë —</button>
                        <div className="grid grid-cols-2 gap-2 max-h-64 overflow-auto">
                            {filteredSubjects.map((s) => (
                                <button key={s.id} onClick={() => saveSlot(s.id)} className={`p-2 rounded-lg border-2 text-xs font-semibold text-left transition ${edit?.subject_id === s.id ? "border-oxford bg-oxford/5" : "border-slate-200 hover:border-slate-300"}`} data-testid={`tt-pick-subject-${s.id}`}>
                                    {s.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <DialogFooter>
                        <Button variant="outline" onClick={() => setEdit(null)}>Anulo</Button>
                    </DialogFooter>
                </DialogContent>
            </Dialog>
        </Layout>
    );
}
